<template>
  <div class="px-4 ml-6 pt-4 layout-row layout-wrap" :style="{'background': compColor.lxExpansion.background}">

    <!-- Kopfdaten -->

    <div class="flex-gt-sm-100 flex-100 mt-2">
      <div class="flex-100 px-3 py-1 mb-3 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.REPORTER_PERSONAL_CONTRIBUTION') }}</span>
      </div>

      <melder path="headerData"
              v-model="model.headerData"
              :formKey="model.formType"
              :additionalItemsList="additionalItemsList"
              :validationRef="validationRef"
              :isImport="true"
              :disableManuallyValidate="true"
      ></melder>
    </div>

    <!-- Grunddaten -->

    <div class="flex-100 px-3 py-1 my-6 mx-2"
         :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
         style="border-radius: 4px;">
      <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.BASE_PROGRESS_SUB_LINE') }}</span>
    </div>

    <div class="layout-row layout-wrap flex-gt-sm-100 flex-100">

      <!-- Tod tumorbedingt? -->

      <div class="flex-gt-sm-100 flex-100 px-2">
        <div class="flex-gt-sm-50 flex-100">
          <validation-provider tag="div"
                               :name="path + '.additionalFields.death.tod_tumorbedingt'"
                               :ref="path + '.additionalFields.death.tod_tumorbedingt'"
                               :rules="{required: true}"
                               class="layout-column"
                               v-slot="{ errors }">
            <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_DEATH_DEPENDS_ON_TUMOR') + ' *'"
                              :errors="errors.length > 0">

              <div class="px-4 pb-2 flex">
                <v-radio-group :dense="denseFields" v-model="model.additionalFields.death.tod_tumorbedingt" row hide-details :error-messages="errors[0]" class="ma-0 pa-0">
                  <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.YES')"
                           value="J" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                  </v-radio>
                  <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.NO')"
                           value="N" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                  </v-radio>
                  <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.UNKNOWN')"
                           value="U" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                  </v-radio>
                </v-radio-group>
              </div>
            </fake-input-frame>

            <!-- Anzeige Fehlermeldung  -->

            <span class="error--text" style="line-height:12px;font-size:12px;margin-top: 3px;margin-left:6px;">{{ errors[0] }}</span>
          </validation-provider>
        </div>
      </div>

      <!-- Todesursachen  -->

      <div class="flex-100 px-2 mb-3 mt-4">
        <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_DEATH_CAUSE_OF_DEATH')">
          <div class="layout-column flex px-2 pb-2">
            <div v-bind:style="{'z-index': '4'}" class="layout-row flex layout-align-start-center pa-1">
              <lx-btn icon="add_circle"
                      :color="compColor.primeColor"
                      :iconColor="'white'"
                      :label="$t('FORMS_DIVERSE.MODULE_DEATH_ADD_CAUSE_OF_DEATH')"
                      :tooltip="$t('FORMS_DIVERSE.MODULE_DEATH_ADD_CAUSE_OF_DEATH')"
                      iconSize="21"
                      :width="'auto'"
                      :height="35"
                      @click="addCauseOfDeath()"
              ></lx-btn>
            </div>

            <div :key="index" v-for="(item, index) in model.additionalFields.death.todesursachen"
                 class="layout-row pa-0 ma-1"
                 :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
                 style="border-radius:4px;"
                 :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

              <div class="layout-row layout-wrap flex pa-4">

                <!-- ICD10-Code der Todesursache  -->

                <div class="flex-gt-sm-33 flex-100 px-2 mb-3">
                  <validation-provider tag="div"
                                       :name="path + '.additionalFields.death.todesursachen.' + index + '.code'"
                                       :ref="path + '.additionalFields.death.todesursachen.' + index + '.code'"
                                       rules="required|min:2"
                                       v-slot="{ errors }">
                    <lx-autocomplete
                      :label="$t('FORMS_DIVERSE.ICD_CODE') + ' *'"
                      v-model="item.code"
                      :error="errors[0]"
                      @search-method="getDataForAutocomplete"
                      @input="setDiagnosis"
                      dense
                      :index="index"
                      :hide-details="!errors || errors.length <= 0"
                      :results="resultSearchModel">
                      <template v-slot="slotProps">
                        <div class="layout-row">
                          <div style="width: 100px;border-radius: 4px;" class="mr-2 px-2 white lighten-2 layout-column layout-align-center-center">
                            <h3>
                              <lx-text-highlight :text="slotProps.lineItem.code" :search-string="slotProps.searchText" :color="compColor.prime"></lx-text-highlight>
                            </h3>
                          </div>
                          <div class="flex">
                          <span class="body-2">
                            <lx-text-highlight :text="slotProps.lineItem.description" :search-string="slotProps.searchText" :color="compColor.prime"></lx-text-highlight>
                          </span>
                          </div>
                        </div>
                      </template>
                    </lx-autocomplete>
                  </validation-provider>
                </div>

                <!-- ICD10-Version der Todesursache  -->

                <div class="flex-gt-sm-66 flex-100">
                  <validation-provider tag="div"
                                       :name="path + '.additionalFields.death.todesursachen.' + index + '.version'"
                                       :ref="path + '.additionalFields.death.todesursachen.' + index + '.version'"
                                       :rules="{required: !!(item && item.code)}"
                                       v-slot="{ errors }">
                    <v-select
                      :items="Primaertumor_ICD_VersionTypes"
                      label="ICD10 Version *"
                      :name="path + '.additionalFields.death.todesursachen.' + index + '.version'"
                      :color="compColor.primeColor"
                      :dark="compColor.isInDarkMode"
                      dense
                      outlined
                      @change="resetICD10Code(index)"
                      class="my-0 mb-2"
                      :persistent-hint="true"
                      :hint="$t('FORMS_DIVERSE.CODE_VERSION_HINT')"
                      v-model="item.version"
                      :error-messages="errors[0]"
                      :menu-props="{ bottom: true, offsetY: true }">
                      <template v-slot:item="{ item, on, attrs }">
                        <v-list-item v-on="on"
                                     :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                          <v-list-item-content class="py-0">
                            <label style="cursor:pointer;"
                                   :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                                   class="lighten-4 text--darken-2">{{ item.text }}</label>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                  </validation-provider>
                </div>

                <!-- Freitext Todesursache  -->

                <div class="flex-gt-sm-100 flex-100 pl-2">
                  <validation-provider tag="div"
                                       :name="path + '.additionalFields.death.todesursachen.' + index + '.description'"
                                       :ref="path + '.additionalFields.death.todesursachen.' + index + '.description'"
                                       rules=""
                                       v-slot="{ errors }">
                    <v-text-field
                      :label="$t('FORMS_DIVERSE.ICD_CODE_TEXT')"
                      :color="compColor.primeColor"
                      :dark="compColor.isInDarkMode"
                      v-model="item.description"
                      disabled
                      :hide-details="!errors || errors.length <= 0"
                      dense
                      outlined
                      :error-messages="errors[0]"
                      class="ma-0"
                    ></v-text-field>
                  </validation-provider>
                </div>
              </div>

              <div class="layout-column layout-align-center-center px-3"
                   :class="{'grey lighten-2': !compColor.isInDarkMode}"
                   :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
                <lx-btn @click="deleteDeathReason(model.additionalFields.death.todesursachen, index, path + '.additionalFields.death.todesursachen.' + index + '.description')"
                        :color="compColor.primeColor"
                        :iconColor="'white'"
                        iconSize="21"
                        :width="35"
                        :height="35"
                        icon="delete_forever"></lx-btn>
              </div>
            </div>
          </div>
        </fake-input-frame>
      </div>

      <!--  ANMERKUNG  -->

      <div class="flex-gt-sm-100 flex-100 mt-3">
        <div class="flex-100 px-3 py-1 mb-6 mx-2"
             :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
             style="border-radius: 4px;">
          <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.ANNOTATION_HEADER') }}</span>
        </div>

        <anmerkung path="additionalFields.death.anmerkung"
                   :isDisabled="isFormDisabled()"
                   v-model="model.additionalFields.death.anmerkung"
                   class="layout-wrap flex-gt-sm-100 flex-100"></anmerkung>
      </div>
    </div>
  </div>
</template>

<script>
import metaData from '../../../components/documentation/shared/formsMetaData'
import utils from '../../../common/utils'
import LxAutocomplete from '../../../components/lx_auto_complete/LxAutocomplete.vue'

import Melder from '../../../components/documentation/shared/Melder'
import Anmerkung from '../../../components/documentation/shared/Anmerkung.vue'

export default {
  name: 'Death',
  mixins: [metaData, utils],
  components: {
    Anmerkung,
    LxAutocomplete,
    Melder
  },
  props: {
    value: {
      type: Object,
      default: () => ({ additionalFields: { death: {} } })
    },
    path: {
      type: String
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    additionalItemsList: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      model: { additionalFields: { death: {} } },
      resultSearchModel: {},
      Primaertumor_ICD_VersionTypes: null
    }
  },
  created () {
    this.Primaertumor_ICD_VersionTypes = this.filterVersions('icd10')
  },
  methods: {
    /**
     * Add empty agent to agent array after clicking 'add'
     */
    addCauseOfDeath () {
      if (!this.model.additionalFields.death.todesursachen) {
        this.$set(this.model.additionalFields.death, 'todesursachen', [])
      }

      this.$set(this.model.additionalFields.death.todesursachen, this.model.additionalFields.death.todesursachen.length, {})
    },

    /**
     * Delete ICD10-code and text after changing version
     *
     * @param index The index of disease-element
     */
    resetICD10Code (index) {
      this.$delete(this.model.additionalFields.death.todesursachen[index], 'code')
      this.$delete(this.model.additionalFields.death.todesursachen[index], 'description')
    },

    /**
     * Get list of icd10 codes via regex in auto-complete
     *
     * @param data The search string
     * @param index The index of selected item
     */
    getDataForAutocomplete (data, index) {
      // clear string from special characters to provide errors
      data = this.clearStringForRegexSearch(data)

      let config = {
        opts: {
          limit: 30
        },
        query: {
          searchValue: data
        }
      }

      // if icd-10 version is set, send it to backend
      const foundVersion = this.Primaertumor_ICD_VersionTypes.find(elem => elem.value === this.model.additionalFields.death.todesursachen[index].version)

      if (foundVersion?.misdValue) {
        config.query.version = foundVersion.misdValue
      }

      this.$http.get('/icd10?config=' + JSON.stringify(config))
        .then(res => {
          this.resultSearchModel = {
            result: res.data.items,
            count: res.data.count,
            version: res.data.version,
            index: index
          }
        })
        .catch(this.NotifyError)
    },

    /**
     * Set icd10 value via list form auto complete
     *
     * @param data The object of selected element in result list
     * @param index The index of selected item
     */
    setDiagnosis (data, index) {
      if (data && data.code) {
        const foundVersion = this.Primaertumor_ICD_VersionTypes.find(elem => elem.misdValue === this.resultSearchModel.version)
        const version = foundVersion?.value ? foundVersion?.value : this.formsMetaData.ICD10_Version

        this.$set(this.model.additionalFields.death.todesursachen[index], 'code', data.code)
        this.$set(this.model.additionalFields.death.todesursachen[index], 'description', data.description)
        this.$set(this.model.additionalFields.death.todesursachen[index], 'version', version)
      } else {
        if (!this.model.additionalFields.death.todesursachen[index].code || typeof data === 'string' || (this.validationRef.errors  && this.validationRef.errors[this.path + '.additionalFields.death.todesursachen.' + index + '.code'] && this.validationRef.errors[this.path + '.additionalFields.death.todesursachen.' + index + '.code'].length > 0)) {
          // nextTick is necessary to trigger watcher in autocomplete on the right way
          this.$nextTick(() => {
            // delete input of icd10, if not selected from result list
            if (typeof data === 'string') this.$set(this.model.additionalFields.death.todesursachen[index], 'code', null)
          })

          this.$set(this.model.additionalFields.death.todesursachen[index], 'description', undefined)
        }
      }
    },

    /**
     * Delete selected element of death causes and trigger validator for saving
     */
    deleteDeathReason (value, index, field) {
      this.$delete(value, index)
      this.$nextTick(() => {
        this.validationRef.fields[field].changed = true
      })
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue && oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue

          if (!this.model.additionalFields) {
            this.$set(this.model, 'additionalFields', { death: {} })
          }
        }
      },
      immediate: true
    }
  }
}
</script>
